var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { observable, action, computed, runInAction } from 'mobx';
import ErrorUtil from '../util/ErrorUtil';
import GravityFormModel from './GravityFormModel';
let GravityFormStore = (() => {
    var _a, _GravityFormStore_initialized_accessor_storage, _GravityFormStore_loading_accessor_storage, _GravityFormStore_error_accessor_storage, _GravityFormStore_forms_accessor_storage, _GravityFormStore_formSubmitResultModalOpen_accessor_storage, _GravityFormStore_app_accessor_storage;
    let _instanceExtraInitializers = [];
    let _initialized_decorators;
    let _initialized_initializers = [];
    let _initialized_extraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _error_decorators;
    let _error_initializers = [];
    let _error_extraInitializers = [];
    let _forms_decorators;
    let _forms_initializers = [];
    let _forms_extraInitializers = [];
    let _formSubmitResultModalOpen_decorators;
    let _formSubmitResultModalOpen_initializers = [];
    let _formSubmitResultModalOpen_extraInitializers = [];
    let _app_decorators;
    let _app_initializers = [];
    let _app_extraInitializers = [];
    let _get_isInitialized_decorators;
    let _get_isLoading_decorators;
    let _get_hasError_decorators;
    let _fetch_decorators;
    let _get_isFormSubmitResultModalOpen_decorators;
    return _a = class GravityFormStore {
            get initialized() { return __classPrivateFieldGet(this, _GravityFormStore_initialized_accessor_storage, "f"); }
            set initialized(value) { __classPrivateFieldSet(this, _GravityFormStore_initialized_accessor_storage, value, "f"); }
            get loading() { return __classPrivateFieldGet(this, _GravityFormStore_loading_accessor_storage, "f"); }
            set loading(value) { __classPrivateFieldSet(this, _GravityFormStore_loading_accessor_storage, value, "f"); }
            get error() { return __classPrivateFieldGet(this, _GravityFormStore_error_accessor_storage, "f"); }
            set error(value) { __classPrivateFieldSet(this, _GravityFormStore_error_accessor_storage, value, "f"); }
            get forms() { return __classPrivateFieldGet(this, _GravityFormStore_forms_accessor_storage, "f"); }
            set forms(value) { __classPrivateFieldSet(this, _GravityFormStore_forms_accessor_storage, value, "f"); }
            get formSubmitResultModalOpen() { return __classPrivateFieldGet(this, _GravityFormStore_formSubmitResultModalOpen_accessor_storage, "f"); }
            set formSubmitResultModalOpen(value) { __classPrivateFieldSet(this, _GravityFormStore_formSubmitResultModalOpen_accessor_storage, value, "f"); }
            get app() { return __classPrivateFieldGet(this, _GravityFormStore_app_accessor_storage, "f"); }
            set app(value) { __classPrivateFieldSet(this, _GravityFormStore_app_accessor_storage, value, "f"); }
            constructor(rootStore) {
                _GravityFormStore_initialized_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _initialized_initializers, false)));
                _GravityFormStore_loading_accessor_storage.set(this, (__runInitializers(this, _initialized_extraInitializers), __runInitializers(this, _loading_initializers, false)));
                _GravityFormStore_error_accessor_storage.set(this, (__runInitializers(this, _loading_extraInitializers), __runInitializers(this, _error_initializers, false)));
                _GravityFormStore_forms_accessor_storage.set(this, (__runInitializers(this, _error_extraInitializers), __runInitializers(this, _forms_initializers, [])));
                _GravityFormStore_formSubmitResultModalOpen_accessor_storage.set(this, (__runInitializers(this, _forms_extraInitializers), __runInitializers(this, _formSubmitResultModalOpen_initializers, false)));
                _GravityFormStore_app_accessor_storage.set(this, (__runInitializers(this, _formSubmitResultModalOpen_extraInitializers), __runInitializers(this, _app_initializers, undefined)));
                Object.defineProperty(this, "api", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: __runInitializers(this, _app_extraInitializers)
                });
                Object.defineProperty(this, "handleFetchSuccess", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ({ data }) => {
                        runInAction(() => {
                            try {
                                this.forms = data.map(({ id, title }) => new GravityFormModel(id, title, this.api));
                                this.initialized = true;
                            }
                            catch (error) {
                                this.error = true;
                                this.initialized = false;
                            }
                            this.loading = false;
                        });
                    }
                });
                Object.defineProperty(this, "handleFetchError", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (error) => {
                        ErrorUtil.pushErrorToTeliaRumAndLog(error);
                        runInAction(() => {
                            this.initialized = false;
                            this.loading = false;
                            this.error = true;
                        });
                    }
                });
                Object.defineProperty(this, "toggleFormSubmitResultModal", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: (isOpen) => {
                        runInAction(() => {
                            this.formSubmitResultModalOpen = isOpen;
                        });
                    }
                });
                this.api = rootStore.api;
                const forms = rootStore.propStateStore.forms;
                this.app = rootStore.propStateStore.app;
                if (forms != null && forms.length > 0) {
                    this.forms = forms.map(({ id, title }) => new GravityFormModel(id, title, this.api));
                    this.initialized = true;
                }
                else {
                    this.fetch();
                }
            }
            get isInitialized() {
                return this.initialized;
            }
            get isLoading() {
                return this.loading;
            }
            get hasError() {
                return this.error;
            }
            fetch() {
                if (!this.loading && !this.initialized) {
                    this.loading = true;
                    this.api.get(`/forms?app=${this.app}`).then(this.handleFetchSuccess).catch(this.handleFetchError);
                }
            }
            get isFormSubmitResultModalOpen() {
                return this.formSubmitResultModalOpen;
            }
            getForm(title) {
                return this.forms.find((form) => form.title === title);
            }
            submitForm(formId, submitPayload) {
                return this.api.post(`/forms/${formId}?app=${this.app}`, {
                    ...submitPayload,
                    isCaptchaV3: true,
                    formUrl: window.location.href
                });
            }
            submitGeopankData(data) {
                return this.api.post('/forms/geopank', data);
            }
        },
        _GravityFormStore_initialized_accessor_storage = new WeakMap(),
        _GravityFormStore_loading_accessor_storage = new WeakMap(),
        _GravityFormStore_error_accessor_storage = new WeakMap(),
        _GravityFormStore_forms_accessor_storage = new WeakMap(),
        _GravityFormStore_formSubmitResultModalOpen_accessor_storage = new WeakMap(),
        _GravityFormStore_app_accessor_storage = new WeakMap(),
        (() => {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _initialized_decorators = [observable];
            _loading_decorators = [observable];
            _error_decorators = [observable];
            _forms_decorators = [observable];
            _formSubmitResultModalOpen_decorators = [observable];
            _app_decorators = [observable];
            _get_isInitialized_decorators = [computed];
            _get_isLoading_decorators = [computed];
            _get_hasError_decorators = [computed];
            _fetch_decorators = [action];
            _get_isFormSubmitResultModalOpen_decorators = [computed];
            __esDecorate(_a, null, _initialized_decorators, { kind: "accessor", name: "initialized", static: false, private: false, access: { has: obj => "initialized" in obj, get: obj => obj.initialized, set: (obj, value) => { obj.initialized = value; } }, metadata: _metadata }, _initialized_initializers, _initialized_extraInitializers);
            __esDecorate(_a, null, _loading_decorators, { kind: "accessor", name: "loading", static: false, private: false, access: { has: obj => "loading" in obj, get: obj => obj.loading, set: (obj, value) => { obj.loading = value; } }, metadata: _metadata }, _loading_initializers, _loading_extraInitializers);
            __esDecorate(_a, null, _error_decorators, { kind: "accessor", name: "error", static: false, private: false, access: { has: obj => "error" in obj, get: obj => obj.error, set: (obj, value) => { obj.error = value; } }, metadata: _metadata }, _error_initializers, _error_extraInitializers);
            __esDecorate(_a, null, _forms_decorators, { kind: "accessor", name: "forms", static: false, private: false, access: { has: obj => "forms" in obj, get: obj => obj.forms, set: (obj, value) => { obj.forms = value; } }, metadata: _metadata }, _forms_initializers, _forms_extraInitializers);
            __esDecorate(_a, null, _formSubmitResultModalOpen_decorators, { kind: "accessor", name: "formSubmitResultModalOpen", static: false, private: false, access: { has: obj => "formSubmitResultModalOpen" in obj, get: obj => obj.formSubmitResultModalOpen, set: (obj, value) => { obj.formSubmitResultModalOpen = value; } }, metadata: _metadata }, _formSubmitResultModalOpen_initializers, _formSubmitResultModalOpen_extraInitializers);
            __esDecorate(_a, null, _app_decorators, { kind: "accessor", name: "app", static: false, private: false, access: { has: obj => "app" in obj, get: obj => obj.app, set: (obj, value) => { obj.app = value; } }, metadata: _metadata }, _app_initializers, _app_extraInitializers);
            __esDecorate(_a, null, _get_isInitialized_decorators, { kind: "getter", name: "isInitialized", static: false, private: false, access: { has: obj => "isInitialized" in obj, get: obj => obj.isInitialized }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_isLoading_decorators, { kind: "getter", name: "isLoading", static: false, private: false, access: { has: obj => "isLoading" in obj, get: obj => obj.isLoading }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_hasError_decorators, { kind: "getter", name: "hasError", static: false, private: false, access: { has: obj => "hasError" in obj, get: obj => obj.hasError }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _fetch_decorators, { kind: "method", name: "fetch", static: false, private: false, access: { has: obj => "fetch" in obj, get: obj => obj.fetch }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(_a, null, _get_isFormSubmitResultModalOpen_decorators, { kind: "getter", name: "isFormSubmitResultModalOpen", static: false, private: false, access: { has: obj => "isFormSubmitResultModalOpen" in obj, get: obj => obj.isFormSubmitResultModalOpen }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { GravityFormStore };
export default GravityFormStore;
//# sourceMappingURL=GravityFormStore.js.map